import React from 'react';
import shortid from 'shortid';
import { get, find, forEach, cloneDeep, isEqual, keys } from 'lodash';

// local dependencies
import { materialMailOut as MaterialMailOutView } from 'ui/views/widgets/materialMailOut';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import * as errorOverlay from 'utils/errorOverlay';
import * as successOverlay from 'utils/successOverlay';
import { GLOBAL_LABELS } from 'constants/common';
import { getLabel } from 'utils/getLabel';
import { MaterialMailOutService } from 'services/materialMailOut';

// import { resolveSecondaryOptionsResolver } from 'resolvers/resolveSecondaryOptions';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MaterialMailOut } from 'ui/containers/MaterialMailOut';
 *
 * // render
 * <MaterialMailOut propName='propValue'/>
 */
export class MaterialMailOut extends React.Component {

    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = this.composeStateFromProps();

        this._bind();
        this.materialMailOutService = new MaterialMailOutService();
    }

    _bind() {

        this.onFormSubmit = this.onFormSubmit.bind( this );
        this.composeStateFromProps = this.composeStateFromProps.bind( this );
        this.handleFormChangeCallback = this.handleFormChangeCallback.bind( this );
    }

    composeStateFromProps() {
        log.debug( 'MaterialMailOut.composeStateFromProps()' );


        //loop over addresses and create new list of options
        const _options = cloneDeep( get( this.props, 'values.options', {} ) );
        forEach( this.props.values.options[ 'memberAddresses' ], ( address ) => {
            const newAddress = {
                name: `${address.line1}`,
                title: {
                    value: `${address.addressType}` + ' - ' + `${address.line1}`
                },
                value: `${address.line1}`
            };
            _options.addresses.push( newAddress );
        } );

        return {
            fields: this.props.fields,
            options: _options,

            values: get( this.props, 'values.state.values' ),
            formId: shortid.generate(),
        };
    }

    handleFormChangeCallback( { values, field } ) {
        log.debug( 'MaterialMailOut.handleFormChangeCallback()' );

        /*-------------------*/
        const _fields = cloneDeep( get( this.props, 'fields', {} ) );
        if( isEqual( field.name, 'memberAddress' )  ) {
            if ( isEqual( 'add', values[ `${field.name}` ] ) ) {

                // enable address related fields
                forEach( _fields, ( currentField ) => {
                    currentField.config.hide = false;
                } );

                values.addressType = '';
                values.line1 = '';
                values.line2 = '';
                values.city = '';
                values.state = '';
                values.zip = '';
            } else {

                // autopopulate fields using props addresses
                const autoPopulateObject = find( this.props.values.options.memberAddresses, { line1: values[ field.name ] } );

                forEach( keys( autoPopulateObject ), _addressKey => {
                    if( ! isEqual( 'id', _addressKey ) ) {
                        values[ _addressKey ] = autoPopulateObject[ _addressKey ];
                    }
                } );

                // enable address related fields
                forEach( _fields, ( currentField ) => {
                    currentField.config.hide = false;
                    if( isEqual( 'addressType', currentField.name ) || isEqual( 'line1', currentField.name ) || isEqual( 'line2', currentField.name ) || isEqual( 'city', currentField.name ) || isEqual( 'state', currentField.name ) || isEqual( 'zip', currentField.name ) ) {
                        currentField.type = 'text';
                        currentField.config.readonly = true;
                    }
                } );
            }
            this.setState( {
                fields: _fields,
                values: values,
                formId: shortid.generate(),
            }, () => {
                log.debug( this.state.fields );
            } );
        } else {

            this.setState( { values } );

        }


        /*-------------------*/
    }

    /**
     * action executed when user clicks on form submit
     */
    async onFormSubmit ( formData ) {
        log.debug( 'MaterialMailOut.onFormSubmit()' );

        const context = get( this.props, 'context', {} );
        const successAction = find( this.props.actions, { name: 'submit' } );

        // close overlay
        this.props.onCancelClick();

        // show page preloader
        pageLevelPreloader.show();

        const { status } = await this.materialMailOutService.submitFormData( {
            url: successAction.url,
            data: {
                context,
                data: formData
            }
        } );

        // hide page preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            successOverlay.open( { message: getLabel( GLOBAL_LABELS.DISPLAY_TEXT_DONE_SUCCESSFULLY ), } );

        } else {
            errorOverlay.open();
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MaterialMailOutView
                { ...this.props }
                { ...this.state }
                onFormSubmit={ this.onFormSubmit }
                onChangeCallBack={ this.handleFormChangeCallback }
            />
        );
    }
}

// set display name
MaterialMailOut.displayName = 'MaterialMailOut';

// set default props
MaterialMailOut.defaultProps = {};

// prop types
MaterialMailOut.propTypes = {};
